var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-barrages",class:{isShow:!_vm.isShowDanMu}},[_c('v-barrage',{attrs:{"initDanmu":_vm.initDanmu,"isPause":_vm.isPause,"arr":_vm.arr,"percent":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }